const FinanceAccountSelector = ({ accounts, selectedAccountId, onAccountSelect }) => {
    return (
        <div>
            <p className="text-lg font-bold text-gray-800 mb-3">Pilih Akun Pembayaran</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {accounts.map(account => (
                    <label
                        key={account.id}
                        className={`
                            relative flex items-center justify-between
                            p-4 border border-gray-300 rounded-lg cursor-pointer
                            transition-all duration-300 ease-in-out
                            hover:shadow-md hover:border-blue-400
                            ${selectedAccountId == account.id
                                ? 'bg-blue-50 border-blue-500 ring-2 ring-blue-400 shadow-lg'
                                : 'bg-white'
                            }
                        `}
                    >
                        <input
                            type="radio"
                            name="finance_account_id"
                            value={account.id}
                            checked={selectedAccountId == account.id}
                            onChange={() => onAccountSelect(account.id)}
                            className="hidden"
                        />
                        <span className={`text-base font-semibold ${selectedAccountId == account.id ? 'text-blue-800' : 'text-gray-700'}`}>
                            {account.name}
                        </span>
                        {selectedAccountId == account.id && (
                            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                        )}
                    </label>
                ))}
            </div>
        </div>
    );
};

export default FinanceAccountSelector; 